import { render, staticRenderFns } from "./OsobaBase.vue?vue&type=template&id=06416397&scoped=true&"
import script from "./OsobaBase.vue?vue&type=script&lang=js&"
export * from "./OsobaBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06416397",
  null
  
)

export default component.exports